import { render, staticRenderFns } from "./WebPortalContent.vue?vue&type=template&id=1960aa28&scoped=true&"
import script from "./WebPortalContent.vue?vue&type=script&lang=js&"
export * from "./WebPortalContent.vue?vue&type=script&lang=js&"
import style0 from "./WebPortalContent.vue?vue&type=style&index=0&id=1960aa28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960aa28",
  null
  
)

export default component.exports